import { render, staticRenderFns } from "./EditAnswer.vue?vue&type=template&id=8f216814&scoped=true&"
import script from "./EditAnswer.vue?vue&type=script&lang=js&"
export * from "./EditAnswer.vue?vue&type=script&lang=js&"
import style0 from "./EditAnswer.vue?vue&type=style&index=0&id=8f216814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f216814",
  null
  
)

export default component.exports